angular.module('common').directive('btnInlineError', ['BtnErrorHandler', 'baseInlineErrorFunctionality', function (BtnErrorHandler, baseInlineErrorFunctionality) {
  return {
    restrict: 'E',
    scope: true,
    transclude: true,
    template: '<div class="inline-error__tooltip-position-wrapper"><span class="inline-error__tooltip skin-tooltip" ng-show="message.content && (hasFocus || hasMouse)">{{message.content}}</span></div>\
      <div class="inline-error__container"><span class="fa-stack btn-inline-error__icon">\
      <i class="fa fa-circle fa-stack-2x"></i><i class="fa fa-stack-1x fa-inverse" ng-class="{\'fa-exclamation-triangle\': message.type == \'alert\', \'fa-info\': message.type == \'info\', \'fa-exclamation\': message.type == \'warning\'}"></i>\
      </span>\
      <ng-transclude/></div>',
    link: function ($scope, $element, $attrs) {
      var errorHandler = new BtnErrorHandler($element);
      errorHandler.onShowMessage(function (message) {
        $scope.message = message;
      });

      $element.on('click', 'button', function() {
        errorHandler.updateMessageVisibility();
        $scope.$digest();
      });

      baseInlineErrorFunctionality('button', $scope, $element, $attrs, errorHandler);
    }
  };
}]);
